import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output
} from '@angular/core';

@Component({
  selector: 'pl-confirm-button',
  templateUrl: './confirm-button.component.html',
  styleUrls: ['./confirm-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConfirmButtonComponent {
  @Input() confirmTranslationKey = 'confirm';
  @Input() i18nBaseKey: string;
  @Input() confirmButtonClasses = 'btn btn-danger';

  @Output() confirm = new EventEmitter();

  @HostListener('mouseleave') mouseLeave() {
    if (this.isArmed) {
      this.isArmed = false;
      this.cdr.markForCheck();
    }
  }

  isArmed = false;

  constructor(private cdr: ChangeDetectorRef) {}
}
